<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-input ttLabel="company_name" [ttModel]="setting.company_name" ttReadonly></tt-input>
        <tt-date ttLabel="balance_date" [(ttModel)]="setting.balance_date" (ttModelChange)="onChanged($event, 'balance_date')"></tt-date>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
